import { defineQuery, useQuery } from "@pinia/colada";
import type { MyPreOrders } from "@/schemas/pre-order";

export const useMyPreOrders = defineQuery(() => {
  const { data: myPreOrders, isLoading, status, error } = useQuery<MyPreOrders, Error, MyPreOrders>({
    key: () => ["my_pre_orders"],
    query: async () => v.parse(myPreOrdersSchema, await ajaxRequest<MyPreOrders>("get_my_pre_orders")),
    placeholderData: { items: [] },
    staleTime: 1000 * 60 * 60 * 24,
  });
  return { myPreOrders, isLoading, status, error };
});
